import dayjs from 'dayjs';

import type { Dayjs } from 'dayjs';

import type { FreelancerAvailability } from 'state/__generated__/tadaahAPI';

export type CalendarCell = {
  date: Dayjs;
  weekday: number;
  className: string;
};

export const getCalendarCellsData = (
  fromDate: Dayjs | undefined,
  currentM: Dayjs | undefined,
  toDate: Dayjs | undefined,
  weekdays: number[],
  availabilityList: FreelancerAvailability[],
): CalendarCell[] => {
  if (!currentM) return [] as CalendarCell[];
  const startingDate = dayjs(currentM).set('date', 1);
  const startingDay = startingDate.day() === 0 ? 6 : startingDate.day() - 1;

  const numberOfDays = startingDate.daysInMonth();
  let calendarCells = [] as CalendarCell[];
  let dayPointer = startingDay;
  let pointerDate = startingDate;
  const getClassName = (date: Dayjs, day: number): string => {
    let className = '';

    if (
      weekdays.length &&
      (date.isSame(fromDate) || date.isAfter(fromDate)) &&
      (date.isSame(toDate) || date.isBefore(toDate)) &&
      weekdays.find((val) => val === day % 7) !== undefined
    ) {
      const value = availabilityList.find(
        (val) => val.date === date.format('YYYY-MM-DD'),
      );
      if (value === undefined) className = 'bg-[#F7F3DA] text-[#8D7A09]';
      else if (value.available) className = 'bg-[#DAF7F5] text-[#1E928F]';
      else className = 'bg-destructive-100 text-destructive-400';
    } else className = 'bg-inherit text-gray-600';
    return className;
  };

  for (let counter = startingDay - 1; counter >= 0; counter -= 1) {
    pointerDate = pointerDate.add(-1, 'd');
    calendarCells.push({
      className: getClassName(pointerDate, counter),
      date: pointerDate,
      weekday: counter,
    });
  }
  calendarCells = calendarCells.reverse();

  pointerDate = startingDate;
  for (let counter = 1; counter <= numberOfDays; counter += 1) {
    calendarCells.push({
      className: getClassName(pointerDate, dayPointer % 7),
      date: pointerDate,
      weekday: dayPointer % 7,
    });
    dayPointer += 1;
    pointerDate = pointerDate.add(1, 'd');
  }

  pointerDate = startingDate.set('date', startingDate.daysInMonth());

  for (
    let counter = calendarCells[calendarCells.length - 1].weekday + 1;
    counter <= 6;
    counter += 1
  ) {
    pointerDate = pointerDate.add(1, 'd');
    calendarCells.push({
      className: getClassName(pointerDate, counter),
      date: pointerDate,
      weekday: counter,
    });
  }

  if (calendarCells.length < 42) {
    for (let counter = 0; counter <= 6; counter += 1) {
      pointerDate = pointerDate.add(1, 'd');
      calendarCells.push({
        className: getClassName(pointerDate, counter),
        date: pointerDate,
        weekday: counter,
      });
    }
  }
  return calendarCells;
};
